import React from 'react';

export const INPUT_MAX_LENGTH = '20';
export const INSERT_LEFT = 'INSERT_LEFT';
export const INSERT_RIGHT = 'INSERT_RIGHT';
export const SUBSTITUTE = 'SUBSTITUTE';
export const ENTER = 'Enter';

export const TOOLBAR_TYPES = {
    TOOLBAR: 'TOOLBAR',
    INSERT_TOOLBAR: 'INSERT_TOOLBAR',
    END_TIME_TOOLBAR: 'END_TIME_TOOLBAR',
};

export const INPUT_PLACEHOLDERS = {
    INSERT_LEFT: 'Insert left',
    INSERT_RIGHT: 'Insert right',
    SUBSTITUTE: 'Substitute word',
};

export const CORRECTIONS = {
    INSERT_LEFT: (
        <>
            L<sup>I</sup>
        </>
    ),
    INSERT_RIGHT: (
        <>
            R<sup>I</sup>
        </>
    ),
    SUBSTITUTE: 'S',
    OMIT: 'O',
    CORRECT: 'C',
};
